
// Angular
import { RouterModule } from '@angular/router';
import { NgbAlertConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialPreviewModule } from '../../views/partials/content/general/material-preview/material-preview.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IntegralUIModule } from '@lidorsystems/integralui-web/bin/integralui/integralui.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AccumulationChartModule } from '@syncfusion/ej2-angular-charts';
import {
	CategoryService, BarSeriesService, ColumnSeriesService, LineSeriesService, LegendService, DataLabelService, MultiLevelLabelService, SelectionService, PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationAnnotationService,
	AccumulationDataLabelService, StackingAreaSeriesService, StackingBarSeriesService, StackingColumnSeriesService, ExportService
} from '@syncfusion/ej2-angular-charts';
import { PartialsModule } from '../partials/partials.module';
import { CoreModule } from '../../core/core.module';
import { ajaxservice } from '../../services/ajaxservice';
import { ExcelService } from './../../services/excelservice';
import { LoaderComponent } from '../pages/loader/loader.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
	declarations: [],
	exports: [RouterModule],
	imports: [
		NgMultiSelectDropDownModule.forRoot(),
		AccumulationChartModule,
		IntegralUIModule,
		CoreModule,
		PartialsModule,
		NgbModule,
		TranslateModule.forRoot(),
		MaterialPreviewModule,
		RouterModule,
		PerfectScrollbarModule,
		MatProgressSpinnerModule,
		MatCardModule,
		MatRadioModule,
		ReactiveFormsModule
	],
	providers: [NgbAlertConfig, ajaxservice, ExcelService, PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationDataLabelService, AccumulationAnnotationService,
		CategoryService,
		BarSeriesService,
		ColumnSeriesService,
		LineSeriesService, LegendService,
		DataLabelService, MultiLevelLabelService,
		SelectionService, StackingAreaSeriesService, StackingBarSeriesService,
		StackingColumnSeriesService, ExportService],
	entryComponents: [
	]
})
export class PagesModule {
}